import { useTranslation } from "next-i18next"

const useAuthUtilityNavi18n = () => {
  const { t } = useTranslation()
  const i18n = {
    signIn: t("Sign In"),
    createAccount: t("Create Account"),
    hi: t("kf.auth.label.hi", "Hi"),
    title: t("kf.auth.label.bannerMssg", "Your Kohler Account"),
    welcome: t("kf.auth.label.welcome", "Welcome Back"),
    logout: t("kf.auth.label.logout", "Sign Out"),
    rightArrowAlt: t("kf.auth.label.rightArrowAlt", "right arrow"),
    leftArrowAlt: t("kf.auth.label.rightArrowAlt", "right arrow"),
    menu: t("kf.auth.label.menu", "Menu"),
    expanded: t("kf.auth.label.expanded", "Expanded"),
    collapsed: t("kf.auth.label.collapsed", "Collapsed"),
    user: t("kf.auth.label.user", "User"),
    orders: t("kf.account.label.orders", "Orders"),
  }

  return i18n
}

export default useAuthUtilityNavi18n
